import { render, staticRenderFns } from "./SimpleUpload.vue?vue&type=template&id=fa023864&scoped=true&"
import script from "./SimpleUpload.vue?vue&type=script&lang=js&"
export * from "./SimpleUpload.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUpload.vue?vue&type=style&index=0&id=fa023864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa023864",
  null
  
)

export default component.exports